import { fetchData } from "@request";

export type Wallet = {
  address: string;
  id: string;
};

export type WalletResponse = Wallet[];

export const getWalletsApi = async (userId: string) => {
  try {
    const response = await fetchData<WalletResponse>({
      url: `api/v1/for_all_role/wallets/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("getWallets failed:", error);
    throw error;
  }
};
